const get = (endpoint) => {
  return fetch(endpoint, {
    method: "get",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
  })
    .then((response) => {
      switch (response.status) {
        case 500:
          throw "服务器出错";
        case 401:
          throw "身份认证信息未提供，请重新登录。";
        case 405:
          throw "访问出错，请重新登录。";
        default: {
          if (response.ok) {
            return response.json();
          } else {
            return Promise.reject(response);
          }
        }
      }
    })
    .then((json) => {
      return json;
    });
};

const getJSON = (endpoint) => {
  return fetch(endpoint, {
    method: "get",
    headers: new Headers({
      "Content-Type": "application/json",
      Accept: "application/json",
    }),
  })
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      return json;
    });
};

const post = (endpoint, parameters) => {
  return fetch(endpoint, {
    method: "post",
    body: parameters,
  })
    .then((response) => {
      switch (response.status) {
        case 500:
          throw "服务器出错";
        case 401:
          throw "身份认证信息未提供，请重新登录。";
        case 405:
          throw "访问出错，请重新登录。";
        default: {
          if (response.ok) {
            return response.json();
          } else {
            return Promise.reject(response);
          }
        }
      }
    })
    .then((json) => {
      return json;
    });
};

export default {
  indicator: (layerName) => {
    return get(`/dashboard/indicator?layerName=${layerName}`);
  },
  situation: (layerName) => {
    return getJSON(`/geojson/echart/${layerName}.json`);
  },
  temperature: (date, lng, lat) => {
    return get(`/api/data/temperature?date=${date}&lon=${lng}&lat=${lat}`);
  },
  order: (userId, page) => {
    return get(`/dashboard/compute/order?userId=${userId}&page=${page}`);
  },
  operation: (point, size = 800, user, uuid) => {
    const lng = Math.floor(point[0]);
    const lat = Math.floor(point[1]);
    return get(
      `/compute/done/Action?longitude=${lng}&dimensionality=${lat}&userId=${user.id}&userName=${user.userName}&mail=${user.mail}&size=${size}&uuid=${uuid}`
    );
  },
  operationStatus: () => {
    return get(`/dashboard/compute/status`);
  },
  operationImage: (userId, uuid) => {
    return get(`/dashboard/compute/order/image?userId=${userId}&uuid=${uuid}`);
  },
  saveSize: (uuid, size) => {
    console.log(uuid, size);
    const data = new FormData();
    data.append("uuid", uuid);
    data.append("size", size);
    return post(`/dashboard/save/size`, data);
  },
  querySize: (uuid) => {
    return get(`/dashboard/query/size?uuid=${uuid}`);
  },
};
